import Attractions from "../../Components/Attractions";
import Banner from "../../Components/Banner";
import Category from "../../Components/Category";
import LatestBlogs from "../../Components/LatestBlogs";
// import PopularDestination from "../../Components/PopularDestination";
import { useTranslation } from "react-i18next"
import PopularDestination from "../../Components/PopularDestination";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { url } from "../../urlConfig";
import { Helmet } from 'react-helmet';

function Home({initialData={}, language}) {
    console.log('Home initialData:', initialData); // Debug log
    const [poi, setPoi] = useState(initialData?.poi?.data);
    const [loadPoi, setLoadPoi] = useState(!!poi);
    const [page, setPage] = useState(initialData?.page?.data);

    // useEffect(() => {
    //     if (initialData.poi === undefined) {
    //         const fetchPoiData = async () => {
    //             try {
    //                 const poiResponse = await axios.get(`${url}/get-all-pois/${language}`);
    //                 setPoi(poiResponse.data.data);
    //                 setLoadPoi(true);
    //             } catch (error) {
    //                 console.error("Error fetching data on client-side navigation:", error);
    //                 setLoadPoi(false);
    //             }
    //         };

    //         fetchPoiData();
    //     } else {
    //         setPoi(initialData.poi.data);
    //     }
    // }, [poi]);

    // useEffect(() => {
    //     if (initialData.page === undefined) {
    //         const fetchBlogs = async () => {
    //             fetch(`https://admin.hopdays.com/api/recent-blogs?limit=10`)
    //                 .then((res) => res.json())
    //                 .then((data) => {
    //                     setPage(data.data);
    //                 })
    //                 .catch((error) => {
    //                     console.error("Error fetching blog:", error);
    //                 });
    //         };

    //         fetchBlogs();
    //     } else {
    //         setPage(initialData.page.data);
    //     }
    // }, [page]);

    return (
        <>
            <Banner language={language} />
            <PopularDestination 
                stateData={initialData?.popular?.data} 
                language={language} 
            />
            <Attractions poi={initialData?.poi?.data} load={loadPoi} language={language} />
            {/* <Category page={initialData?.page?.data} language={language}/> */}
            <LatestBlogs blogsData={page} language={language} />
        </>
    );
}

export default Home;